import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M362.7 19.3L314.3 67.7L444.3 197.7L492.7 149.3C517.7 124.3 517.7 83.8 492.7 58.8L453.3 19.3C428.3 -5.7 387.8 -5.7 362.8 19.3H362.7ZM291.7 90.3L58.6 323.5C48.2 333.9 40.6 346.8 36.4 360.9L0.999997 481.2C-1.5 489.7 0.799997 498.8 7 505C13.2 511.2 22.3 513.5 30.7 511.1L151 475.7C165.1 471.5 178 463.9 188.4 453.5L421.7 220.3L291.7 90.3Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
